<template>
  <v-row v-if="$can('view', 'InventoryLog')">
    <v-col
      sm="3"
      class="hidden-xs-only"
    >
      <div style="position: sticky; top: 20px">
        <v-subheader class="justify-space-between pr-0">
          Filters
          <v-btn
            v-if="isFiltered"
            text
            color="red"
            @click="clearFilters"
          >
            <v-icon
              small
              left
            >
              close
            </v-icon>
            Clear
          </v-btn>
        </v-subheader>
        <v-text-field
          v-model="filtersDirty.label"
          label="Label"
          solo
          clearable
          hide-details
          class="mb-2"
        />
        <v-text-field
          v-model="filtersDirty.code"
          label="Code"
          solo
          clearable
          hide-details
          class="mb-2"
        />
      </div>
    </v-col>
    <v-col
      cols="16"
      sm="13"
    >
      <pagination
        :from="inventoryLogs.meta.from"
        :to="inventoryLogs.meta.to"
        :total="inventoryLogs.meta.total"
        :last-page="inventoryLogs.meta.last_page"
        :page.sync="pagination.page"
        class="align-center mb-2"
      />
      <v-data-table
        :headers="inventoryLogs.headers"
        :items="inventoryLogs.data"
        :page.sync="pagination.page"
        :sort-by.sync="sorting.sortBy"
        :sort-desc.sync="sorting.desc"
        :loading="inventoryLogs.loading"
        :server-items-length="inventoryLogs.meta.total"
        item-key="id"
        must-sort
        hide-default-footer
        class="elevation-5"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="font-weight-medium">
              {{ item.event.replace('App\\Events\\InventoryItem', '').replace(/([a-z])([A-Z])/g, '$1 $2') }}
            </td>
            <td>
              {{ item.inventory_item.label }}
            </td>
            <td>
              <span
                v-if="item.inventory_item.code"
                class="grey--text"
              >
                {{ item.inventory_item.code }}
              </span>
              <span
                v-else
                class="grey--text"
              >
                n/a
              </span>
            </td>
            <td :class="{ 'error--text': !item.amount }">
              {{ item.amount | currency('') }} <span class="grey--text">
                {{ item.inventory_item.unit }}
              </span>
            </td>
            <td>
              {{ item.user.staff.name }}
            </td>
            <td>
              {{ item.service_task ? item.service_task.title : 'n/a' }}
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <!--<editor-fold desc="Filtered">-->
          <div
            v-if="isFiltered"
            class="text-center py-4"
          >
            <div>
              There are no results for your search.
            </div>
            <div
              class="mt-2"
            >
              <v-btn
                small
                text
                @click="clearFilters"
              >
                <v-icon left>
                  clear
                </v-icon>
                Clear Filters
              </v-btn>
            </div>
          </div>
          <!--</editor-fold>-->
          <!--<editor-fold desc="NoData">-->
          <div
            v-else
            class="text-center py-4"
          >
            <v-col cols="16">
              There are no service tasks at the moment.
            </v-col>
          </div>
          <!--</editor-fold>-->
        </template>
      </v-data-table>
      <pagination
        :from="inventoryLogs.meta.from"
        :to="inventoryLogs.meta.to"
        :total="inventoryLogs.meta.total"
        :last-page="inventoryLogs.meta.last_page"
        :page.sync="pagination.page"
        class="align-center mt-2"
      />
    </v-col>
  </v-row>
</template>

<script>
  import cloneDeep from 'lodash/cloneDeep'
  import serviceCurrentLocationMixin from '@/mixins/serviceCurrentLocationMixin'
  import paginationMixin from '@/mixins/paginationMixin'
  import filterableMixin from '@/mixins/filterableMixin'
  import InventoryLog from '@/models/InventoryLog'

  export default {
    name: 'InventoryItemsActivity',
    mixins: [paginationMixin, filterableMixin, serviceCurrentLocationMixin],
    data() {
      return {
        inventoryLogs: {
          headers: [
            { text: 'Event', value: 'event', sortable: false },
            { text: 'Item', value: 'inventory_item.label', sortable: false },
            { text: 'Code', value: 'inventory_item.code', sortable: false },
            { text: 'Amount', value: 'amount', sortable: false },
            { text: 'User', value: 'user.name', sortable: false },
            { text: 'Service Task', value: 'service_task.title', sortable: false }
          ],
          data: [],
          loading: false,
          meta: {}
        },
        pagination: {
          perPage: 30
        },
        filtersClean: cloneDeep(InventoryLog.emptyFilters),
        filtersDirty: cloneDeep(InventoryLog.emptyFilters)
      }
    },
    created() {
      this.fetchInventoryLogs()
    },
    methods: {
      onPaginationUpdate() { this.fetchInventoryLogs() },
      onFiltersUpdate() { this.resetPagination() },
      onCurrentLocationUpdate() { this.resetPagination() },
      async fetchInventoryLogs() {
        this.inventoryLogs.loading = true

        const queryParams = {
          ...this.paginationQueryParams,
          ...this.filterQueryParams,
          ...this.currentLocationQueryParams
        }

        try {
          const result = await InventoryLog.api.fetch(queryParams)

          this.inventoryLogs.data = result.data
          this.inventoryLogs.meta = result.meta
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.inventoryLogs.loading = false
        }
      }
    }
  }
</script>
